/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { useLayout } from '../../core'
import { AsideMenu } from './AsideMenu'
import { useAuth } from '../../../../app/modules/auth'
import ModelPopup from '../RhEALComponent/ModelPopup'
import { LogoutUser } from '../../../../app/modules/redux'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'


const AsideDefault: FC = () => {
  // const [modelToggle, setModelToggle] = useState<boolean>(false);
  const { classes } = useLayout()
  // const { logout } = useAuth()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const logoutClick = () => {
    dispatch(LogoutUser())
    navigate('/')
  }
  return (
    <div
      id='kt_aside'
      className='aside'
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      <div className='aside-toolbar flex-column-auto' id='kt_aside_toolbar'>
      </div>
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      <div className='aside-footer flex-column-auto py-5' id='kt_aside_footer'>
        <a
          // onClick={() => logout()}
          onClick={() => logoutClick()}
          className='btn btn-custom btn-primary w-100'
          target='_blank'
          data-bs-toggle='tooltip'
          data-bs-trigger='hover'
          data-bs-dismiss-='click'
        >
          <span className='btn-label'>Log out</span>
        </a>
      </div>
      {/* {modelToggle
        && <ModelPopup />
      } */}
    </div >
  )
}

export { AsideDefault }
